import { Checkbox, Input, Label, Textarea } from "@tellescope/ui";
import { TemplateFormDialogContentsSectionForm } from "./types";
import { useTranslation } from "react-i18next";

export interface PortalSectionProps {
  form: TemplateFormDialogContentsSectionForm<
    | "displayTitle"
    | "displayDescription"
    | "requirePortalCancelReason"
    | "preventCancelInPortal"
    | "preventRescheduleInPortal"
  >;
}

export const PortalSection = ({ form }: PortalSectionProps) => {
  const { t } = useTranslation("calendar");

  return (
    <section className="space-y-6">
      <div className="space-y-4">
        <Label htmlFor="displayTitle">{t("Display Title")}</Label>
        <Input
          id="displayTitle"
          {...form.getFieldProps("displayTitle")}
          placeholder={t("Custom title for patient portal")}
        />
      </div>
      <div className="space-y-4">
        <Label htmlFor="displayDescription">{t("Display Description")}</Label>
        <Textarea
          id="displayDescription"
          {...form.getFieldProps("displayDescription")}
          placeholder={t("Custom description for patient portal")}
        />
      </div>
      <div className="space-y-4">
        <span className="flex gap-2 items-center">
          <Checkbox
            checked={form.values.requirePortalCancelReason}
            onCheckedChange={(checked) => form.setFieldValue("requirePortalCancelReason", !!checked)}
            id="requirePortalCancelReason"
          />
          <Label htmlFor="requirePortalCancelReason">{t("Require cancellation reason in portal")}</Label>
        </span>
        <span className="flex gap-2 items-center">
          <Checkbox
            checked={form.values.preventCancelInPortal}
            onCheckedChange={(checked) => form.setFieldValue("preventCancelInPortal", !!checked)}
            id="preventCancelInPortal"
          />
          <Label htmlFor="preventCancelInPortal">{t("Prevent cancellation in portal")}</Label>
        </span>
        <span className="flex gap-2 items-center">
          <Checkbox
            checked={form.values.preventRescheduleInPortal}
            onCheckedChange={(checked) => form.setFieldValue("preventRescheduleInPortal", !!checked)}
            id="preventRescheduleInPortal"
          />
          <Label htmlFor="preventRescheduleInPortal">{t("Prevent reschedule in portal")}</Label>
        </span>
      </div>
    </section>
  );
};
